import { Plan } from './components/Plan';
import withTableController from '../../../../../HOC/tableController/withTableControllerForAdminPlanning';

const Plan24 = withTableController(({ planing, state }) => (
  <Plan planing={planing} state={state} />
));

export default Plan24;
